import { render, staticRenderFns } from "./NftManagerDetails.vue?vue&type=template&id=bb3a1dc8&"
import script from "./NftManagerDetails.vue?vue&type=script&lang=js&"
export * from "./NftManagerDetails.vue?vue&type=script&lang=js&"
import style0 from "./NftManagerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports